import React from "react";
import { inject, observer } from "mobx-react";
import gameActionOptions from "../constants/gameActionOptions";
import GameActionsDropDown from "../components/GameActionsDropDown";

class InternationalIndependentGameActionDropDownContainer extends React.Component {
  render() {
    const { InternationalIndependentGameActionStore } = this.props.rootStore;

    return (
      <GameActionsDropDown
        game={this.props.game}
        gameActionOptions={gameActionOptions}
        transitionToCreateIncident={
          InternationalIndependentGameActionStore.trackingAccuracyReportSource
            .transitionToCreateIncident
        }
        clearClippyCache={
          InternationalIndependentGameActionStore.clearClippyCache
        }
        clearStatsApiCache={
          InternationalIndependentGameActionStore.clearStatsApiCache
        }
        resendGame={InternationalIndependentGameActionStore.resendGame}
      />
    );
  }
}

export default inject("rootStore")(
  observer(InternationalIndependentGameActionDropDownContainer),
);
